module.exports.isBrowserIOS = navigator.userAgent.match(/iPad|iPhone|iPod/) && !window.MSStream;

module.exports.isHandheld = function() {
  return typeof window.orientation !== 'undefined';
};

module.exports.lengthString = seconds => {
  seconds = Math.floor(seconds);
  if (isNaN(seconds)) return '--:--';
  if (!isFinite(seconds)) return '--:--';
  if (seconds <= 0) return '0:00';
  var minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;
  var hours = Math.floor(minutes / 60);
  minutes -= hours * 60;
  if (seconds < 10) seconds = '0' + seconds;
  if (!hours) {
    return minutes + ':' + seconds;
  }
  if (minutes < 10) minutes = '0' + minutes;
  return hours + ':' + minutes + ':' + seconds;
};

module.exports.getElementPosition = element => {
  let xPos = 0, yPos = 0;
  while (element) {
    xPos += (element.offsetLeft - element.scrollLeft + element.clientLeft);
    yPos += (element.offsetTop - element.scrollTop + element.clientTop);
    element = element.offsetParent;
  }
  return { x: xPos, y: yPos };
};

const getChromeVersion = () => {
  let ver = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  if (!ver) return 0;
  return parseFloat(ver[2]);
};
module.exports.chromeVersion = getChromeVersion();

const getFirefoxVersion = () => {
  let ver = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
  if (!ver) return -1;
  return parseFloat(ver[1]);
};
module.exports.firefoxVersion = getFirefoxVersion();
